/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
declare let base: any;
declare let hall: any;
declare let WebDefine: any;
declare type SystemTipsCbTag = any;
import { log } from '@/utils/functions'
import { ModuleBase } from './ModuleBase'
import { Country } from '@/defines/EnumDefine'

export class ConfigModule extends ModuleBase {
  country: Country = Country.Pakistan

  init(): void {}

  onClear(): void {}

  onLoad(): void {}

  onDestroy(): void {}

  onPreloadData(): void {
    log('ConfigModule onPreloadData')
    // let data = {
    //     c: base.channelId,
    //     u: hall.userModule.userId,
    //     v: "1.0",
    // }
    // base.httpUtil.postJson(WebDefine.blockConfig, data)
    //     .then(data => {
    //         log('success:', data)
    //     })
    //     .catch(error => {
    //         log('error:', error)
    //     });
  }

  inits2c(): void {}

  postConfigData(): void {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
    }
    base.httpUtil
      .postJson(WebDefine.config, data)
      .then((response) => {
        log('postConfigData success:', response)
        if (response.code == 200) {
          this.country = response.data.country as Country
          //  hall.Language.moneySign = response.data.moneySign;
          base.app.areaCode = response.data.phonePrefix

          hall.eventDispatcher.emit(hall.EventDefine.ConfigChange)
        } else {
          log('postConfigData fail:', response)
          const params = {
            callback: (_tag: SystemTipsCbTag) => {
              //this.postConfigData();
            },
          }
          const content = `${hall.Language.ConfigError}` //(${response.code})
          base.uiHudSystem.show('SystemTips', content, params)
        }
      })
      .catch((_error: any) => {
        log('postConfigData error:', error)

        const params = {
          callback: (_tag: SystemTipsCbTag) => {
            // this.postConfigData();
          },
        }
        base.uiHudSystem.show('SystemTips', hall.Language.ConfigError, params)
      })
  }
}
